import { Consolidate, CurdDataSetConfig, FormFieldType } from '../types';
import { durationToString, getTimezone, toDateFormat, toTimeFormat } from '@mri/functions';
import { formatDate } from '@angular/common';

export const consolidatesDataSetConfig: CurdDataSetConfig<Consolidate> = {
  entityName: 'Consolidado',
  collectionName: 'Consolidados',
  gatewayUrl: 'consolidates',
  baseBreadcrumb: 'consolidates',
  list: {
    pageConfig: {
      title: 'Reporte de consolidados',
      breadcrumb: [
        {
          title: 'Reportes',
          type: 'item',
        },
        {
          title: 'Consolidados',
          type: 'item',
          link: '/reports/diary-consolidates/list',
          pageName: 'Reporte de consolidados'
        }
      ]
    },
    table: {
      columns: [
        {
          key: 'mobileName', label: 'Placa',
          getValue: ({ element }) =>
            element.mobile?.name ?? element.device?.name ?? 'No definido'
        },
        { key: 'day', label: 'Dia', getValue: ({ element }) =>  element.day.split('T').shift() ?? 'No definido' },

        {
          key: 'distance', label: 'Odometro',
          getValue: ({ element, component }) => {
            const calcVars = component?.configSrv.calcVars;

            if(!calcVars?.distanceUnit) return 'No definido';

            const value = element.odometer * (calcVars?.distanceUnit.multiply ?? 1);
            const unit = calcVars?.distanceUnit.abbr ?? '';
            return `${value.toFixed(2)} ${unit}`;
          }},
        {
          key: 'maxSpeed', label: 'Velocidad maxima',
          getValue: ({ element, component }) => {
            const calcVars = component?.configSrv.calcVars;

            if(!calcVars?.speedUnit) return 'No definido';

            const value = (element.speedMaxNode?.speed ?? 0) * (calcVars?.speedUnit.multiply ?? 1);
            const unit = calcVars?.speedUnit.abbr ?? '';
            return `${value.toFixed(2)} ${unit}`;
          }

        },
        {
          key: 'powerOnTime', label: 'Tiempo encendido',
          getValue: ({ element }) => element.worktime ? durationToString(element.worktime) : ''
        },
        {
          key: 'powerOffTime', label: 'Tiempo apagado',
          getValue: ({ element }) => element.worktime ? durationToString((1000 * 60 * 60 * 24) - element.worktime): ''
        },
        { key: 'positionCount', label: 'Posiciones', getValue: ({ element }) => element.positionCount.toFixed(0) },
        { key: 'stopCount', label: 'Paradas' },
        { key: 'alarmEventCount', label: 'Alarmas' },
        {
          key: 'lastDeviceTime', label: 'Ultimo reporte',
          getValue({ element }) {
            return element.lastNode?.deviceTime ? toTimeFormat(element.lastNode.deviceTime) : 'No definido';
          }
        },
      ],
      noInitLoad: true,
      modeFilter: 'top'
    },
    actionsKeys: ['export-xls'],
    filter: [
      {
        key: 'mobileId',
        label: 'Vehiculo',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsGateway: 'mobiles',
        containerClass: 'col-12 col-md-6'
      },
      {
        key: 'day',
        label: 'Dia',
        type: FormFieldType.DATE,
        containerClass: 'col-12 col-md-6',
        fillDefaultValue: () => {
          const now = new Date().toJSON();
          const timezone = getTimezone();
          console.log('timezone', timezone);
          const defaultDay = toDateFormat( now);
          console.log('defaultDay', defaultDay);
          return defaultDay;
        }
      },
    ],
  },
  pages: ['list']
};
